import { Injectable } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';

@Injectable({ providedIn: 'root' })
export class ThreeDSecureCommand extends BaseProductCommand {
  // Теперь title и type - это методы, которые вычисляют значение на основе контекста
  public get title(): string {
    return '3D Secure';
  }

  public get type(): string {
    return 'threeDsecureEnable'; // 'threeDsecureDisable'
  }

  readonly icon = 'secure';
  readonly productType = ProductTypes.CARD;
  readonly isInfoAction = true;
  readonly settingsNames = undefined;

  get order(): number {
    return this.getContextualOrder({
      [ProductTypes.CARD]: 80           // Карты: 3D Secure (8-й в списке "прочее")
    }, 999);
  }

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private navigationService: NavigationService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push(`product/${context.data.id}/action/${this.type}`, {
      state: {
        productCode: context.data.productCode
      }
    });
  }
}

